import { atom } from "jotai";

import { HoleCount } from "@whoosh/design-system/src/components/icons_v2/courseLayout";

import { selectedRoundAtom } from "../../stores";

export const setCourseLayoutHoleCountOnRoundAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      courseLayoutHoleCount: HoleCount;
    }
  ) => {
    const selectedRound = get(selectedRoundAtom);
    if (!selectedRound) {
      return;
    }

    set(selectedRoundAtom, {
      ...selectedRound,
      courseLayoutHoleCount: payload.courseLayoutHoleCount,
    });
  }
);
